import { api } from "./api";

export interface Lesson {
  id: string;
  host_user_id: string;
  title: string;
  starts_at: number;
  ends_at: number;
  livekit_room_name: string;
  status: "scheduled" | "live" | "ended" | "cancelled";
  max_participants: number;
  created_at: number;
}

export interface Participant {
  lesson_id: string;
  user_id: string;
  role: "host" | "student";
  joined_at: number | null;
  left_at: number | null;
}

export interface Slot {
  id: string;
  teacher_user_id: string;
  starts_at: number;
  ends_at: number;
}

export interface TeacherProfile {
  user_id: string;
  name: string | null;
  bio: string | null;
  subjects: string[];
  hourly_rate_pln: number | null;
  timezone: string;
}

export const lessonsApi = {
  listMine: () => api<{ lessons: Lesson[] }>("GET", "/api/lessons/mine"),
  get: (id: string) =>
    api<{ lesson: Lesson; participants: Participant[] }>("GET", `/api/lessons/${id}`),
  create: (input: {
    title: string;
    starts_at: number;
    ends_at: number;
    max_participants?: number;
    student_user_ids?: string[];
  }) => api<{ lesson: Lesson }>("POST", "/api/lessons", input),
  cancel: (id: string) => api<{ ok: true }>("POST", `/api/lessons/${id}/cancel`),
  join: (id: string) => api<{ ok: true }>("POST", `/api/lessons/${id}/join`),
};

export const teachersApi = {
  list: () => api<{ teachers: TeacherProfile[] }>("GET", "/api/teachers"),
  availability: (teacherId: string, from?: number, to?: number) =>
    api<{ slots: Slot[] }>(
      "GET",
      `/api/teachers/${teacherId}/availability${
        from || to ? `?${new URLSearchParams({
          ...(from ? { from: String(from) } : {}),
          ...(to ? { to: String(to) } : {}),
        }).toString()}` : ""
      }`,
    ),
  myProfile: () => api<{ profile: TeacherProfile | null }>("GET", "/api/me/teacher-profile"),
  upsertProfile: (input: {
    bio?: string;
    subjects?: string[];
    hourly_rate_pln?: number;
    timezone?: string;
  }) => api<{ profile: TeacherProfile }>("POST", "/api/me/teacher-profile", input),
};

export const availabilityApi = {
  mine: (from?: number, to?: number) =>
    api<{ slots: Slot[] }>(
      "GET",
      `/api/availability${
        from || to ? `?${new URLSearchParams({
          ...(from ? { from: String(from) } : {}),
          ...(to ? { to: String(to) } : {}),
        }).toString()}` : ""
      }`,
    ),
  create: (input: { starts_at: number; ends_at: number }) =>
    api<{ slot: Slot }>("POST", "/api/availability", input),
  remove: (id: string) => api<{ ok: true }>("DELETE", `/api/availability/${id}`),
};

export const recordingsApi = {
  forLesson: (lessonId: string) =>
    api<{
      recordings: Array<{
        id: string;
        status: string;
        storage_path: string | null;
        duration_s: number | null;
        created_at: number;
        ended_at: number | null;
      }>;
    }>("GET", `/api/lessons/${lessonId}/recordings`),
};
